import Vue from "vue";
import * as componentesProsegur from "@/components/look/";

const componentesProsegurConst: { [key: string]: unknown } = componentesProsegur;

Object.keys(componentesProsegur).forEach((key: string) => {
  Vue.component(key, componentesProsegurConst[key] as Vue);
});
